import axios from 'axios'
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        messages: {},
        unreadMessages: {},
        unreadMessagesByLead: {},
        loadingMessages: false,
    },
    mutations: {
        SET_MESSAGES(state, messages) {
            state.messages = messages;
        },
        SET_UNREAD_MESSAGES(state, messages) {
            state.unreadMessages = messages;
        },
        SET_UNREAD_MESSAGES_BY_LEAD(state, messages) {
            state.unreadMessagesByLead = messages;
        },
        DELETE_UNREAD_MESSAGE(state, message_id) {
          state.unreadMessages = state.unreadMessages.filter(msg => msg.id !== message_id);
          state.unreadMessagesByLead = state.unreadMessagesByLead.filter(msg => msg.id !== message_id);
        },
        SOCKET_ADD_MESSAGE(state, message) {
            state.messages.push(message);
        },
        SOCKET_UPDATE_SEND_STATUS(state, message) {
            let index = state.messages.findIndex(item => item.id === message.id);

            state.messages[index] = message;

            Vue.set(state.messages, index, state.messages[index]);
        },
    },
    getters: {
        messages: state => state.messages,
        unreadMessages: state => state.unreadMessages,
        unreadMessagesByLead: state => state.unreadMessagesByLead,
        loadingMessages: state => state.loadingMessages,
    },
    actions: {
        loadMessages({ commit }, lead_id) {
            axios.get("/message/lead/" + lead_id).then(res => {
                commit("SET_MESSAGES", res.data);
            }).catch(e => {
                console.log(e);
            });
        },
        loadUnreadMessages({ commit }, user_id) {
            return new Promise(resolve => {
                axios.get("/message/unread/user/" + user_id).then(res => {
                    commit("SET_UNREAD_MESSAGES", res.data);
                    resolve(res.data);
                }).catch(e => {
                    console.log(e);
                });
            });
        },

    },
}
